import '../badge/gb-badge.tag.html';
riot.tag2('gb-collection-item', '<a class="gb-collection" data-collection="{item}" onclick="{_scope.switchCollection}"> <span class="gb-collection__name">{_scope.labels[item] || item}</span> <gb-badge if="{_scope._config.counts}">{_scope.counts[item]}</gb-badge> </a>', '', '', function(opts) {
});



/** WEBPACK FOOTER **
 ** ./src/tags/collections/gb-collection-item.tag.html
 **/